.pageScroll {
  position: fixed;
  top: var(--top);
  left: 0;
  width: 100%;
  z-index: 1;
  border: 0;
  border-radius: 0;
  height: var(--page-scroll-height);
}
.pageScroll::-webkit-progress-bar {
  background-color: var(--page-scroll-background-color);
}
.pageScroll::-webkit-progress-value {
  background-color: var(--page-scroll-bar-color);
}
.pageScroll::-moz-progress-bar {
  background-color: var(--page-scroll-bar-color);
}
